import React, { useEffect, useRef, useState } from 'react';
import { TextField, Autocomplete, Typography } from '@mui/material';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import Tooltip from '@src/components/Tooltip';
import { COLOR } from '@src/styles/color';
import { StyledAutoComplete, StyledMenuItem } from './index.style';

const AutoComplete = ({
  label,
  name,
  value = '',
  placeholder = '',
  onChange,
  error = false,
  helperText = '',
  disabled = false,
  options,
  customStyle,
  tooltipTitle,
  renderOption,
  isChangeValueWhenBlur = false,
  onFocus,
  onBlur,
}) => {
  const [open, setOpen] = useState(false);
  const [openTooltip, setOpenTooltip] = useState(false);
  const [textValue, setTextValue] = useState(value);

  const inputRef = useRef(null);

  const handleClose = (newValue) => {
    if (isChangeValueWhenBlur && onChange) {
      onChange(textValue);
    } else {
      setTextValue(newValue);
    }
    setOpen(false);
    setTimeout(() => {
      inputRef.current?.blur();
    }, 50);
  };

  const handleSelectedValue = (newValue) => {
    setTextValue(newValue);
    if (onChange) onChange(newValue);
    handleClose(newValue);
  };

  const handleKeyDown = (e) => {
    const { value: newValue } = e.target;

    if (e.key === 'Enter') {
      handleSelectedValue(newValue);
    }
  };

  const handleFocusInput = () => {
    onFocus?.();
    setTextValue(value);
  };

  const handleBlurInput = () => {
    onBlur?.();
    handleClose(value);
  };

  const handleChangeInput = (event) => {
    setTextValue(event.target.value);
  };

  const handleIsOptionEqualToValue = (option, newValue) => option === newValue;

  const handleOnClick = () => {
    // if (isMoreButton) handleCloseSearchBox();
    // else handleCloseSearchBoxAndMoreMenu();
  };

  useEffect(() => {
    // if (currentBreakTime) {
    setTextValue(value);
    // }
  }, [value]);
  return (
    <StyledAutoComplete customStyle={customStyle}>
      <Typography className="input-label">{label}</Typography>
      <Autocomplete
        value={value}
        isOptionEqualToValue={handleIsOptionEqualToValue}
        open={open}
        name={name}
        disabled={disabled}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        options={options}
        filterOptions={(option) => option}
        disableClearable
        popupIcon={
          <ArrowDropDownRoundedIcon
            sx={{ color: COLOR.indigo[80], fontSize: '24px' }}
          />
        }
        renderInput={(params) => (
          <Tooltip
            arrow
            title={tooltipTitle}
            placement="top"
            open={!!(tooltipTitle && openTooltip)}
            disableHoverListener
            onMouseEnter={() => setOpenTooltip(!open)}
            onMouseLeave={() => setOpenTooltip(false)}
          >
            <TextField
              {...params}
              value={textValue}
              inputRef={inputRef}
              className="text-field"
              onFocus={handleFocusInput}
              error={error}
              onBlur={handleBlurInput}
              onChange={handleChangeInput}
              onKeyDown={handleKeyDown}
              placeholder={placeholder}
              color="iconPrimary"
              onClick={handleOnClick}
            />
          </Tooltip>
        )}
        getOptionLabel={(option) => option?.value || option}
        renderOption={(props, option) =>
          renderOption ? (
            renderOption(props, option, handleSelectedValue)
          ) : (
            <StyledMenuItem
              key={option}
              active={String(value) === String(option)}
              onClick={() => handleSelectedValue(option)}
            >
              <Typography variant="body2" className="text">
                {option}s
              </Typography>
            </StyledMenuItem>
          )
        }
      />
      {error && <Typography className="input-error">{helperText}</Typography>}
    </StyledAutoComplete>
  );
};

export default AutoComplete;
